/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../common';
import Page from 'flarum/common/components/Page';
import AchievementCategoriesState from '../../../common/states/AchievementCategoriesState';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import AchievementsHero from './AchievementsHero';
import AchievementItem from '../../../common/components/AchievementItem';
import AchievementCategoriesDropdown from './AchievementCategoriesDropdown';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.achievements`;

export default class AchievementsPage extends Page {
	oninit(vnode) {
		super.oninit(vnode);

		const gamificationEnabled = app.forum.attribute(`${slug}.gamification.enabled`);
		if (!gamificationEnabled) {
			m.route.set('/');
		}

		this.categoryId = m.route.param('category');

		app.history.push('achievements');
		this.bodyClass = 'App--achievements';
		app.setTitle(t(`${prfx}.title`));

		this.state = new AchievementCategoriesState();
		this.state.refresh(true, true);
	}

	onbeforeupdate(vnode) {
		super.onbeforeupdate(vnode);

		const { loading, achievement_categories } = this.state;

		if (this.categoryId === 'undefined' && !loading && achievement_categories.length) {
			m.route.set(app.route('achievements', { category: achievement_categories[0].id() }));
		}
	}

	view() {
		const { loading, achievement_categories } = this.state;

		const category = this.categoryId ? achievement_categories?.find((c) => +c.id() === +this.categoryId) : null;

		return (
			<div className="AchievementsPage">
				<AchievementsHero category={category} loading={loading} achievement_categories={achievement_categories} />
				<div className="container">
					{loading && <LoadingIndicator />}
					<div className="sideNavContainer">
						<nav className="AchievementsPage-nav sideNav">
							{!!achievement_categories?.length && (
								<AchievementCategoriesDropdown achievement_categories={achievement_categories} categoryId={this.categoryId} />
							)}
						</nav>
						<div className="AchievementsPage-content sideNavOffset">
							{category?.achievements() &&
								category
									.achievements()
									.sort((a, b) => a.order() - b.order())
									.filter((a) => !!a.levels() && a.levels().length)
									.map((achievement) => (
										<AchievementItem
											achievement={achievement}
											showDetails={true}
											link={app.route('achievement', {
												id: achievement.id(),
											})}
											clickable={true}
										/>
									))}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
